module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-28f48e7f.png";